import React, { useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewModal = ({ id, title, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const style = `{                                      
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
   .custom-modal {
 
  overflow-y-auto; /* Enable scrolling if the content overflows */
}
    
    `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-700 dark:text-white w-1/2 rounded-lg"
        isOpen={isViewModalOpen}
        onClose={() => {
          closeModal();
        }}
      >
        <ModalBody className="custom-modal" style={{ margin: "0" }}>
          <CommonCloseBtn
           onClose={closeModal}/>
          <h2 className="text-center font-bold text-lg">{title}</h2>

          <div
            className="max-h-96 overflow-y-auto p-5"
            style={{ maxHeight: "60vh", scrollbarWidth: "thin" }}
          >
            <dl className="border rounded-lg border-gray-300 dark:border-gray-500 text-sm dark:text-white">
              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  URL
                </dt>
                <dd
                  className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20 "
                  style={{
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                  }}
                >
                  {result?.url}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Title
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.title}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Keyword
                </dt>

                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.keywords}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Description
                </dt>

                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.description}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Content
                </dt>
                <dd
                  className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20"
                  dangerouslySetInnerHTML={{ __html: result?.content }}
                />
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  From City
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.from_city}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  To City
                </dt>

                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.to_city}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Type of Trip
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result?.type_of_trip}
                </dd>
              </div>

              <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                <dt className="font-medium text-gray-900 dark:text-gray-200">
                  Created Date
                </dt>
                <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
                  {result && result["added_date"]
                    ? new Intl.DateTimeFormat("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        second: "numeric",
                        hour12: true,
                      }).format(new Date(result["added_date"]))
                    : ""}
                </dd>
              </div>

              {/* <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
        <dt className="font-medium text-gray-900 dark:text-gray-200">Updated Date</dt>
        <dd className="text-gray-700 dark:text-gray-200 sm:col-span-2 pl-20">
          {result && result["updated_date"]
            ? new Intl.DateTimeFormat("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: true,
              }).format(new Date(result["update_date"]))
            : ""}
        </dd>
      </div> */}
            </dl>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
